export default "__VITE_ASSET__D2hx6oam__"